import Glide, { Controls, Swipe } from '@glidejs/glide/dist/glide.modular.esm'

export default function InitImageTextTileSlider() {
    if (window.neos || document.body.classList.contains('neos-backend')) {
        return
    }

    const getResponsiveSettings = () => {
        if (window.matchMedia('(max-width: 575px)').matches) {
            return {
                perView: 1,
                peek: { before: 0, after: 0 },
                gap: 12,
            }
        }

        if (window.matchMedia('(max-width: 767px)').matches) {
            return {
                perView: 2,
                peek: { before: 0, after: 0 },
                gap: 16,
            }
        }

        if (window.matchMedia('(max-width: 1199px)').matches) {
            return {
                perView: 3,
                peek: { before: 0, after: 0 },
                gap: 16,
            }
        }

        // denser, narrower cards with a sliver of the next one peeking in
        // from the right — client-requested redesign, replacing the
        // previous 3-large-cards-per-view look
        return {
            perView: 4,
            peek: { before: 0, after: 80 },
            gap: 16,
        }
    }

    document.querySelectorAll('[data-image-text-tile-slider]').forEach((sliderEl) => {
        if (!sliderEl.querySelector('.glide__slide')) {
            return
        }

        const responsiveSettings = getResponsiveSettings()

        // no loop (client request, applies to every slider on the site) —
        // "carousel"/rewind let you keep clicking next forever and wrap
        // back to the start; "slider" + bound:true stops firmly at the
        // last slide instead. The prev/next buttons are Glide's own native
        // "controls" (data-glide-el="controls" + data-glide-dir on each
        // button, see ImageTextTileSlider.fusion) — Glide handles their
        // clicks itself and automatically adds the disabled class at either
        // end. That option is nested as classes.arrow.disabled (NOT
        // classes.disabledArrow, despite what glide's own README examples
        // suggest) — confirmed against node_modules/@glidejs/glide/src/
        // defaults.js; the wrong key silently no-ops instead of erroring.
        const glide = new Glide(sliderEl, {
            type: 'slider',
            bound: true,
            // glide.js defaults "rewind" to true even for "slider" type
            // (it's not just a "carousel" thing) — without this explicit
            // override it silently wraps around again and Controls never
            // disables the arrows (it bails out early whenever rewind is
            // truthy, see its setArrowState())
            rewind: false,
            perView: responsiveSettings.perView,
            peek: responsiveSettings.peek,
            gap: responsiveSettings.gap,
            animationDuration: 520,
            animationTimingFunc: 'cubic-bezier(0.22, 1, 0.36, 1)',
            classes: {
                slides: 'image-text-tile-slider__slides',
                arrow: {
                    disabled: 'image-text-tile-slider__arrow--disabled',
                },
            },
        })

        glide.mount({ Controls, Swipe })

        window.addEventListener('resize', () => {
            const nextSettings = getResponsiveSettings()

            glide.update({
                perView: nextSettings.perView,
                peek: nextSettings.peek,
                gap: nextSettings.gap,
            })
        })
    })
}
